import styled from "styled-components";

export const StyledFilterBadgeClearable = styled.span`
  align-items: center;
  background: var(--Peach, #f3d9da);
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  gap: 4px;
  justify-content: center;
  line-height: 20px;
  padding: 0px 8px;

  &:hover {
    background-color: var(--GREY, #4a4a68);
    color: var(--CLOUD, #fcfdfe);
  }
`;
